package com.gastoncantera.intercom.ui

import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

/** Web: no-op (Fullscreen API exige gesto de usuario). */
@Composable
actual fun HideSystemUi(active: Boolean) = Unit

@Composable
actual fun Modifier.immersiveContentInsets(avoidCameraCutout: Boolean): Modifier =
    windowInsetsPadding(WindowInsets.safeDrawing)
